import React, { ReactNode } from 'react';
import { Box, Typography, Divider, Paper, Button } from '@mui/material';
import closeIcon from '../../../assets/icons/closeIcon.svg';

interface ModalProps {
  onClose: () => void;
  heading1?: string;
  heading2?: string;
  heading3?: string;
  heading4?: string;
  description1?: string;
  description2?: string;
  description3?: string;
  description4?: string;
  extraContent?: ReactNode;
  title?: string;
  content?: string;
}
export const AddOnInfoModal = (props: ModalProps) => {
  return (
    <Box
      sx={{
        maxWidth: 400,
        borderRadius: '0.9375rem',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column'
      }}
      component={Paper}
      className={'width-75'}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '1rem 1rem'
        }}
      >
        <Button
          onClick={props.onClose}
          sx={{ padding: 0, marginLeft: 'auto', minWidth: 0 }}
          data-testid="#close-info-modal"
        >
          <img src={closeIcon} alt="Close" />
        </Button>
        {props.heading1 && props.description1 && (
          <Box sx={{ display: 'flex', paddingTop: '0.625rem' }}>
            <Typography
              sx={{
                fontFamily: 'Calibri',
                fontSize: '1rem',
                fontWeight: 700,
                lineHeight: '1.25rem',
                color: '#002A3A'
              }}
            >
              {props.heading1}
              {/* T MAX */}
              <span
                style={{
                  fontFamily: 'Calibri',
                  fontSize: '1rem',
                  fontWeight: 400,
                  lineHeight: '1.25rem',
                  color: '#002A3A'
                }}
              >
                {props.description1}
                {/* {` = maximum body temperature in degrees from previous 24 hours, or most recent body temperature`} */}
              </span>
            </Typography>
          </Box>
        )}
        {props.heading2 && props.description2 && (
          <Box sx={{ display: 'flex', paddingTop: '0.625rem' }}>
            <Typography
              sx={{
                fontFamily: 'Calibri',
                fontSize: '1rem',
                fontWeight: 700,
                lineHeight: '1.25rem',
                color: '#002A3A'
              }}
            >
              {props.heading2}
              {/* T MAX */}
              <span
                style={{
                  fontFamily: 'Calibri',
                  fontSize: '1rem',
                  fontWeight: 400,
                  lineHeight: '1.25rem',
                  color: '#002A3A'
                }}
              >
                {props.description2}
                {/* {` = maximum body temperature in degrees from previous 24 hours, or most recent body temperature`} */}
              </span>
            </Typography>
          </Box>
        )}
        {props.heading3 && props.description3 && (
          <Box sx={{ display: 'flex', paddingTop: '0.625rem' }}>
            <Typography
              sx={{
                fontFamily: 'Calibri',
                fontSize: '1rem',
                fontWeight: 700,
                lineHeight: '1.25rem',
                color: '#002A3A'
              }}
            >
              {props.heading3}
              {/* T MAX */}
              <span
                style={{
                  fontFamily: 'Calibri',
                  fontSize: '1rem',
                  fontWeight: 400,
                  lineHeight: '1.25rem',
                  color: '#002A3A'
                }}
              >
                {props.description3}
                {/* {` = maximum body temperature in degrees from previous 24 hours, or most recent body temperature`} */}
              </span>
            </Typography>
          </Box>
        )}
        {props.heading4 && props.description4 && (
          <Box
            sx={{
              display: 'flex',
              paddingTop: '0.625rem'
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Calibri',
                fontSize: '1rem',
                fontWeight: 700,
                lineHeight: '1.25rem',
                color: '#002A3A'
              }}
            >
              {props.heading4}
              {/* T MAX */}
              <span
                style={{
                  fontFamily: 'Calibri',
                  fontSize: '1rem',
                  fontWeight: 400,
                  lineHeight: '1.25rem',
                  color: '#002A3A'
                }}
              >
                {props.description4}
                {/* {` = maximum body temperature in degrees from previous 24 hours, or most recent body temperature`} */}
              </span>
            </Typography>
          </Box>
        )}
        {props.extraContent && (
          <Box
            sx={{
              display: 'flex',
              paddingTop: '0.625rem'
            }}
          >
            {props.extraContent}
          </Box>
        )}
      </Box>
      {props.content && (
        <Box sx={{ padding: '0.9375rem', paddingTop: 0 }}>
          <Divider sx={{ width: '100%' }} />
          {props.title && (
            <Typography
              align="left"
              sx={{
                fontFamily: 'calibri',
                fontSize: '1rem',
                fontStyle: 'italic',
                fontWeight: 700,
                color: '#004F71',
                paddingTop: '1.25rem'
              }}
            >
              {props.title}
              {/* Reference: */}
            </Typography>
          )}
          <Typography
            align="left"
            sx={{
              fontFamily: 'calibri',
              fontSize: '1rem',
              fontWeight: 400,
              lineHeight: '1.25rem',
              color: '#004F71'
            }}
          >
            {props.content}
            {/* Irish Nutrition and Dietetic Institute (2022) Nutrition Support
          Reference Guide. */}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
